define([
    "./translateModule",
    "./recursiveTranslate",
    "./groupTranslate"
], function () {
});

